export default {
  default: 'assets/img/pins/pin.png',
  selectedPin: 'assets/img/pins/selected-pin.png',
  'Econt Express': 'assets/img/pins/econt-pin.png',
  Speedy: 'assets/img/pins/speedy-pin.png',
  Cdek: 'assets/img/pins/cdek-pin.png'
}
